 import React, {useEffect, useState} from "react";
import Budgets from "../../budget/Budgets";
import TimesSpent from "../../time-spent/TimesSpent";
import CounterModal from "../../modal/CounterModal";
import styled from "styled-components";
import TitleSection from "./TitleSection";
import {useSelector} from "react-redux";
import Weather from "./weather-and-advancement/Weather";
import Advancement from "./weather-and-advancement/Advancement";
import SuccessDifficultyThreat from "../../project/pitch/SuccessDifficultyThreat";
import TextareaModal from "../../modal/TextareaModal";
import EditButton from "../../buttons/EditButton";
import NextReviewModal from "../../modal/NextReviewModal";
import {getDateInFrench} from "../../../utils/dateUtils";
import {ROLE_AMBASSADOR, ROLE_CODIR, ROLE_ENJOY} from "../../../permissions/roleTypes";
import EditBudgetModal from "../../modal/EditBudgetModal";
const EvaluationSection = ({
                                  toggleHandler,
                                  inEvaluationSection
                              }) => {


    const [openEditBudgetModal, setOpenEditBudgetModal] = useState(false);
    const [openEditTimeSpentModal, setOpenTimeSpentModal] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [fieldSelected, setFieldSelected] = useState("")
    const {difficulties, success, threatCreated, threatNotCreated, weather, nextReview} = useSelector(state => state.project)
    const currentUser = useSelector(state => state.currentUser)
    const project = useSelector(state => state.project)
    const [canProcess, setCanProcess] = useState(true)
    const [errorMessage, setErrorMessage] = useState("")
    const [openNextReview, setOpenNextReview] =useState(false)
    const nextReviewFR = nextReview? getDateInFrench(nextReview) : ""
    const choicesArea1 = [
        {
            id: 1,
            name: "success",
            value: success,
        },
        {
            id: 2,
            name: "difficulties",
            value: difficulties,
        },
    ]
    const choicesArea2 = [
        {
            id: 3,
            name: "threatCreated",
            value: threatCreated,
        },
        {
            id: 4,
            name: "threatNotCreated",
            value: threatNotCreated,
        },

    ]

    const editItem = (fieldSelected) => {
        setFieldSelected(fieldSelected)
        setIsEditModalOpen(true)
    }
    useEffect(() => {
        if((weather === "rainy" || weather === "stormy") && (difficulties === "" || difficulties === null) && inEvaluationSection)
        {
            setCanProcess(false);
            setErrorMessage("Vous semblez être en difficulté sur ce projet, merci d'indiquer pourquoi dans le champ \"Cailloux\"")
        }
        else{
            setCanProcess(true);
            setErrorMessage("")
        }
    }, [canProcess, difficulties, weather, errorMessage, inEvaluationSection])

    return (
        <Container>
            {
                openNextReview &&

                <NextReviewModal
                    setOpen={setOpenNextReview}
                    project={project}
                />
            }
            <TitleSection
                toggleHandler={toggleHandler}
                title={"Bilan et évaluation"}
                canProcess={canProcess}
            />
            <NextReview>
                <h2>Prochaine revue de projet : {nextReviewFR ? nextReviewFR: "à déterminer"}</h2>
                {
                    (currentUser.roles.includes(ROLE_CODIR) || currentUser.roles.includes(ROLE_AMBASSADOR)
                        || currentUser.roles.includes(ROLE_ENJOY) || currentUser.isPilot || currentUser.isCopilot)
                    &&
                    <EditButton
                        setUpdate={setOpenNextReview}
                        data={openNextReview}
                    />
                }
            </NextReview>
            <ItemsContainer>
                <Item>
                    <Weather/>
                    <Advancement/>
                </Item>
                {
                    errorMessage !== "" &&
                    <ErrorMessageContainer>
                        <p>{errorMessage}</p>
                    </ErrorMessageContainer>
                }
                <Grid>
                    {choicesArea1.map(c => (
                        <SuccessDifficultyThreat
                            value={c.value}
                            name={c.name}
                            key={c.id}
                            canBeUpdated={true}
                            openModal={editItem}
                        />
                    ))}
                </Grid>
                <BudgetAndTime>
                        <Budgets
                        openEditBudgetModal={openEditBudgetModal}
                        setOpenEditModal={setOpenEditBudgetModal}
                        />

                    <TimesSpent
                        openEditTimeSpentModal={openEditTimeSpentModal}
                        setOpenEditModal={setOpenTimeSpentModal}
                    />
                </BudgetAndTime>
                <Grid>
                    {choicesArea2.map(c => (
                        <SuccessDifficultyThreat
                            value={c.value}
                            name={c.name}
                            key={c.id}
                            canBeUpdated={true}
                            openModal={editItem}
                        />
                    ))}
                </Grid>
            </ItemsContainer>

            {openEditBudgetModal &&
                <EditBudgetModal
                    setOpenEditModal={setOpenEditBudgetModal}
                />
            }

            {openEditTimeSpentModal &&
                <CounterModal
                    setOpenEditModal={setOpenTimeSpentModal}
                    title={'Modifier le temps effectif'}
                    property={"realTimeSpent"}
                />
            }
            {isEditModalOpen &&
                <TextareaModal
                    name={fieldSelected}
                    setIsOpen={setIsEditModalOpen}
                />
            }
        </Container>
    )
}

const Grid = styled.div`
  display: grid;
  gap: 1rem;
  padding-bottom: 2rem;
  @media (min-width: 900px) {
    grid-template-columns: repeat(2, 50%);
  }
`

const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 3rem;
`

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 2rem;
  @media (min-width: 900px) {
    height: 100%;
    padding: 1rem;
    width: 90%;
    margin-bottom: 3rem;
  }
`
const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  gap: 2rem;
  @media (min-width: 900px) {
    gap: 5rem;
    flex-direction: row;
  }

  h2 {
    text-align: left;
  }
`
const BudgetAndTime = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  gap: 2rem;
`
const ErrorMessageContainer = styled.div`
  background: #ff4754;
  border-radius: 0.8rem;
  padding: 1rem;
  text-align: center;
  p{
    color: white;
    font-weight: bold;
    font-size: 1rem;
    
  }
`

const NextReview = styled.div`

  display: flex;
  align-items: center;

`


export default EvaluationSection;